var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookingsIconColored(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 9.25H24.25M6.75 1.75V4.25M19.25 1.75V4.25M5.5 14.25H8M5.5 19.25H8M11.75 14.25H14.25M11.75 19.25H14.25M18 14.25H20.5M18 19.25H20.5M5.75 24.25H20.25C21.6501 24.25 22.3502 24.25 22.885 23.9775C23.3554 23.7378 23.7378 23.3554 23.9775 22.885C24.25 22.3502 24.25 21.6501 24.25 20.25V8.25C24.25 6.84987 24.25 6.1498 23.9775 5.61502C23.7378 5.14462 23.3554 4.76217 22.885 4.52248C22.3502 4.25 21.6501 4.25 20.25 4.25H5.75C4.34987 4.25 3.6498 4.25 3.11502 4.52248C2.64462 4.76217 2.26217 5.14462 2.02248 5.61502C1.75 6.1498 1.75 6.84987 1.75 8.25V20.25C1.75 21.6501 1.75 22.3502 2.02248 22.885C2.26217 23.3554 2.64462 23.7378 3.11502 23.9775C3.6498 24.25 4.34987 24.25 5.75 24.25Z",
    stroke: "#394B42",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingsIconColored);
export default __webpack_public_path__ + "static/media/bookings_icon_colored.5063719132fc6f3b4f5eea8dea6045f4.svg";
export { ForwardRef as ReactComponent };